export default "__VITE_ASSET__xAHM0v6g__"